import theme from '../../ui/theme'
import {DEAUTHENTICATE_USER} from "../../Authentication/reducer";
import log from 'loglevel'
import {t} from 'i18next'

export const SET_DEVICES = 'SET_DEVICES';
export const UPDATE_DEVICE = 'UPDATE_DEVICE';
export const ACTIVATE_DEVICE = 'ACTIVATE_DEVICE';
export const GET_SYSTEM = 'GET_SYSTEM'


const defaultScopeModel = {
    label: 'Wohnzimmer',
    mode: 1,
    ventilationLevel: 2,
    nextTime: '',
    timers: [
        { label: (t('Misc.label_swtichtime') + ' 1'), time: new Date(), selectedMode: 1, ventilationLevel: 1, active: true },
        { label: (t('Misc.label_swtichtime') + ' 2'), time: new Date(
                                                    2017, 8, 26, 15, 30, 0, 0
                                                    ),
            selectedMode: 2, ventilationLevel: 2, active: false,
        },
        { label: (t('Misc.label_swtichtime') + ' 3'), time: new Date(), selectedMode: 4, ventilationLevel: 3, active: false },
        { label: (t('Misc.label_swtichtime') + ' 4'), time: new Date(), selectedMode: 1, ventilationLevel: 4, active: false },
        { label: (t('Misc.label_swtichtime') + ' 5'), time: new Date(), selectedMode: 6, ventilationLevel: 5, active: false },
    ],
    color: theme.palette.card.orange,
    senorValues: {
        thresholds: {
            co2: {
                limit: 1200,
                current: 1023,
            },
            humidity: {
                limit: 50,
                current: 62,
            },
        },
        slumberTime: 45,
    },
}

const defaultModel = {
    id: "",
    label: "",
    messages: {
        current: "",
        last: "",
    },
    scopes: {
    },
    gateWayAndDevices: {
        articleCode: "",
        deviceId: "",
        firmware: "",
        centralControl: "",
        tftTouch: ""
    },
    uptime: new Date(
        1900, 0, 0, 0, 0
    ),
    senorValues: { 
        rf: "",
        co2: "", 
        ti: "", 
        ta: "" 
    },
};

export function applyModel (defaultModel, data) {
    const obj =  data;
    obj.deviceid = obj.deviceid && obj.deviceid.split('-').pop();
    // obj.label = obj.deviceid  || obj.id && obj.id.substr(-5); // @FIXME only temporary
    obj.scopes = { 'default': defaultScopeModel }; // @FIXME only temporary

    return obj;
}

export function applyList (list) {
    const map = {};
    list.forEach((item) => {
        item = applyModel(defaultModel, item); // set id
        map[item.id] = item;
    });
    return map;
}

function setActive (state, id) {
    const lastActiveId = state.active;
    const map = state.map;
    const currentActive = map[lastActiveId]
    if (lastActiveId && currentActive) map[lastActiveId].active = false;
    if (typeof map[id] !== "undefined") {
        log.debug("setActive", id)
        map[id].active = true;
    }
    else {
        id = Object.keys(map)[0];
        log.debug("setActive", id)
        map[id].active = true;
    }
    return {
        ...state,
        active: id,
        map,
    };
}

// also create
export function updateItem (map, item) {
    map[item._id] = item;
    return Object.assign({}, map);
}

export function removeItem (map, itemid) {
    delete map[itemid];
    return Object.assign({}, map);
}

const defaultState = {
    active: undefined,
    map: {},
};

/**
 * Devices reducer
 * @param  {Object} [state=defaultState] the previous state
 * @param  {Object} action               the action to apply
 * @return {Object}                      the new state
 */
export default function (state = defaultState, action) {
    switch (action.type) {
        case "UPDATE_CURRENT_USER":
            if (action.currentUser && action.currentUser.activeDevice) {
                return setActive(state, action.currentUser.activeDevice);
            }
            return state;

        case ACTIVATE_DEVICE:
            log.debug("ACTIVATE_DEVICE", state, action)
            return setActive(state, action.id);
        case SET_DEVICES:
            log.debug("SET_DEVICES", state, action)
            let found = action.devices.find(o => o.id === state.active)

            if (typeof found === "undefined") {
                log.debug("SET_DEVICES set to inactive", state.active)
                state.active = null
            }
            
            if (action.devices.length > 0 && !state.active) {
                state.map = applyList(action.devices);
                
                state = setActive(state, action.devices[0].id)
            } else {
                state.map = applyList(action.devices);
            }
            log.debug("state map", state.map)
            return {
                ...state,
            };
        case UPDATE_DEVICE:
            log.debug("UPDATE_DEVICE", state, action)
            return {
                ...state,
                map: updateItem(state.map, action.device),
            };
        case DEAUTHENTICATE_USER:
            return { active: undefined, map: {} }
        case GET_SYSTEM:
            log.debug("GET SYSTEM REDUCER, ACTION: ", action)
            return state
        default:
            return state
    }
}
